import { MenuItem } from "@mui/material"
import { ReactElement } from "react"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Order } from "../../../controlKitchenTypes"

type MenuActionKey = "showReceipt" | "refund" | "messageCustomer"

type MenuItemConfig = {
    key: MenuActionKey
    element: ReactElement
}

type OrderAccountingMenuProps = {
    order: Order
    onShowReceipt: (order: Order) => void
    onRefund?: (order: Order) => void
    onMessageCustomer?: (order: Order) => void
    onClose: () => void
}

export function OrderAccountingMenu({
    order,
    onShowReceipt,
    onRefund,
    onMessageCustomer,
    onClose,
}: OrderAccountingMenuProps) {
    const handleShowReceipt = () => {
        onShowReceipt(order)
        onClose()
    }

    const handleRefund = () => {
        onRefund?.(order)
        onClose()
    }

    const handleMessageCustomer = () => {
        onMessageCustomer?.(order)
        onClose()
    }

    const menuItemsConfig: MenuItemConfig[] = [
        {
            key: "showReceipt",
            element: (
                <LocalizedStrict id="office-purchase-receipt" key={`receipt-${order.id}`}>
                    <MenuItem onClick={handleShowReceipt}>Receipt</MenuItem>
                </LocalizedStrict>
            ),
        },
        {
            key: "refund",
            element: (
                <LocalizedStrict id="order-action-menu-refund" key={`refund-${order.id}`}>
                    <MenuItem onClick={handleRefund}>Refund</MenuItem>
                </LocalizedStrict>
            ),
        },
        {
            key: "messageCustomer",
            element: (
                <LocalizedStrict id="transactions-table-list-message-customer" key={`message-customer-${order.id}`}>
                    <MenuItem onClick={handleMessageCustomer}>Message customer</MenuItem>
                </LocalizedStrict>
            ),
        },
    ]

    // as we don't have orderAction for now - we just return the menu items elements
    const menuItems = menuItemsConfig.map((item) => item.element)

    return <>{menuItems}</>
}

